import React from "react";

export const LoadingScreen = () => {
    return (
        <div>
            <h2 style={{ textAlign: 'center', marginTop: '300px' }}>
                <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                </div>
            </h2>
        </div>
    );
};